import { createRouter, createWebHistory } from 'vue-router'
import { trackPageView } from '../services/AnalyticsService'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Game Finder - Random Game Recommendation'
    }
  },
  {
    path: '/game/:id',
    name: 'Game',
    component: () => import('../views/Game.vue'),
    meta: {
      title: 'Game Experience - Game Finder'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      title: 'About Us - Game Finder'
    }
  },
  {
    path: '/manage',
    name: 'GameManager',
    component: () => import('../views/GameManager.vue'),
    meta: {
      title: 'Game Management - Game Finder'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Game Finder - Random Game Recommendation'
  next()
})

// Route after hook for Google Analytics page tracking
router.afterEach((to) => {
  // Track page views
  trackPageView(to.fullPath, to.meta.title || 'Game Finder - Random Game Recommendation')
})

export default router